<template>
  <div>
    <div class="legal-hero">
      <div class="col">
        <div class="legal-eyebrow">Legal</div>
        <h1 class="legal-title">Política de Repasse</h1>
        <p class="legal-sub">
          Como funciona o recebimento de valores e o repasse aos motoristas e
          transportadores parceiros que executam os fretes.
        </p>
      </div>
    </div>

    <div class="col legal-col">
      <div class="legal-bloco" v-revela>
        <p class="legal-updated">Última atualização: julho de 2026</p>

        <h3 class="legal-h">1. Objeto desta política</h3>
        <p class="legal-p">{{ EMPRESA.nome }} ({{ EMPRESA.razao }}, CNPJ {{ EMPRESA.cnpj }}) contrata motoristas e transportadores parceiros para a execução dos fretes solicitados por seus clientes. Quando previamente acordado, realiza o recebimento dos valores junto ao cliente contratante e o subsequente repasse ao parceiro responsável pela execução. Esta política descreve as regras desse fluxo financeiro.</p>

        <h3 class="legal-h">2. A quem se aplica</h3>
        <p class="legal-p">Aplica-se aos <strong>parceiros</strong> — motoristas autônomos, agregados e transportadores pessoa jurídica — que executam fretes sob contratação da {{ EMPRESA.nome }}. As condições comerciais do <strong>cliente contratante</strong> constam na proposta e nos <router-link to="/termos" class="legal-link">Termos de Uso</router-link>.</p>

        <h3 class="legal-h">3. Composição do valor</h3>
        <p class="legal-p">O valor cobrado do cliente contratante é composto pelo valor do frete devido ao parceiro executor somado à taxa de serviço da {{ EMPRESA.nome }}, referente à captação do cliente, roteirização, coordenação da operação e responsabilidade sobre a carga durante o transporte. Ambos os valores são definidos e comunicados antes da contratação.</p>

        <h3 class="legal-h">4. Como funciona o repasse</h3>
        <p class="legal-p">Quando aplicável, o valor recebido do cliente é repassado ao parceiro executor conforme o valor de frete acordado com ele <strong>antes</strong> do início da viagem. Nenhum percentual adicional é descontado do valor combinado após a confirmação do frete.</p>

        <h3 class="legal-h">5. Valor combinado antes da viagem</h3>
        <p class="legal-p">O valor do frete é acordado com o parceiro antes do início do deslocamento, considerando rota, tipo de carga, distância e tempo estimado. O valor acordado não sofre alteração após a confirmação, salvo por alteração solicitada pelo próprio cliente durante a execução — situação em que o novo valor é combinado com o parceiro antes de prosseguir.</p>

        <h3 class="legal-h">6. Prazo de repasse</h3>
        <p class="legal-p">O repasse é realizado em <strong>até 10 dias úteis</strong> após a confirmação da entrega, por PIX ou transferência bancária para a conta indicada pelo parceiro no cadastro. Fretes com comprovação de entrega pendente têm o prazo contado a partir da regularização do comprovante.</p>

        <h3 class="legal-h">7. Formas de recebimento aceitas</h3>
        <p class="legal-p">O recebimento junto ao cliente contratante pode ocorrer por PIX, transferência bancária, boleto ou cartão, conforme combinado na proposta. A forma de recebimento escolhida pelo cliente não altera o prazo nem o valor do repasse ao parceiro.</p>

        <h3 class="legal-h">8. Comprovação</h3>
        <p class="legal-p">Cada operação gera comprovante de entrega e comprovante de repasse, disponibilizados ao parceiro. Em caso de divergência de valores, o parceiro deve comunicar em até 7 dias corridos do recebimento para verificação e, se for o caso, correção.</p>

        <h3 class="legal-h">9. Descontos e retenções</h3>
        <p class="legal-p">Não há desconto sobre o valor acordado, exceto nos casos previamente comunicados e aceitos pelo parceiro: avarias comprovadamente causadas por manuseio inadequado, extravio de mercadoria sob responsabilidade do parceiro, ou adiantamentos já pagos referentes ao mesmo frete.</p>

        <h3 class="legal-h">10. Cancelamento de frete</h3>
        <p class="legal-p">Frete cancelado pelo cliente após o parceiro já ter iniciado o deslocamento para a coleta gera pagamento proporcional ao trajeto percorrido, combinado caso a caso. Cancelamento antes do deslocamento não gera cobrança nem repasse para nenhuma das partes.</p>

        <h3 class="legal-h">11. Documentação exigida</h3>
        <p class="legal-p">Para receber o repasse, o parceiro deve manter atualizados: documento de identificação, CNH válida na categoria exigida pelo veículo, documento do veículo em dia e dados bancários de titularidade própria ou da pessoa jurídica cadastrada. O repasse não é realizado para conta de terceiros.</p>

        <h3 class="legal-h">12. Transparência</h3>
        <p class="legal-p">Tanto o valor de frete do parceiro quanto a taxa de serviço da {{ EMPRESA.nome }} são informados de forma clara antes da contratação e não sofrem alteração unilateral após a confirmação. Custos adicionais eventuais — espera excedente, ajudante, retorno sem entrega — são informados e acordados antes de qualquer cobrança.</p>

        <h3 class="legal-h">13. Contato</h3>
        <p class="legal-p">
          {{ EMPRESA.razao }}<br>
          CNPJ: {{ EMPRESA.cnpj }}<br>
          {{ EMPRESA.endereco }} — {{ EMPRESA.bairro }}<br>
          {{ EMPRESA.cidade }} — {{ EMPRESA.cep }}<br>
          {{ CONTATO.email }} &nbsp;·&nbsp; {{ CONTATO.telefoneExibicao }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { CONTATO, EMPRESA } from '@/config/contato'
</script>

<style src="@/assets/legal.css" scoped></style>
<style scoped>
.legal-link { color: var(--azul-esc); font-weight: 600; }
</style>
